
<v-select
    v-if              = "items"
    :items            = "items"
    item-value        = "id"
    item-text         = "name"
    :label            = "label"
    v-model           = "seletced"
    :return-object    = true
    :rules            = "rules"
    @change           = "onChange"
    :readonly         = "readonly"
    :hide-details     = "hideDetails"
    :multiple         = "multiple"
    :clearable        = "clearable"
    :background-color = background
>
    <template v-slot:selection="{ item }">
        <div class="item-selection v-list-item__title">
            {{ item.name }}
        </div>
    </template>
</v-select>
